const account = {
	name: 'Konto | Konten',
	fields: {
		hp_id: 'Kontonummer',
		account_name: {
			name: 'Bezeichnung',
		},
		account_type: 'Kontoart',
		accounting_year: {
			year: 'Jahr',
		},
		journals_count: 'Buchungen',
		comments_count: 'Kommentare',
		balances: 'Salden',
	},
}

export default account
